module.exports = __webpack_public_path__ + "img/H01122-158.0e1126d3.jpg";